/**
 * @copyright © Paramount Streaming
 * @description API paths for the Pluto TV converged adapter.
 * Paths are relative to the base URL ending in /api; full URL = base + path (e.g. .../api/v3.0/...).
 * Keep in sync with PTV_CONVERGED_API_PATHS in test_templates/demos/js/plutoTvConfig.js.
 */
export const PLUTO_API_PATHS = {
	/** List all channels: GET .../v3.0/live/channels.json */
	channels: '/v3.0/live/channels.json',
	/** Single channel by slug: GET .../v3.0/live/channels/{slug}.json */
	channelBySlug: '/v3.0/live/channels',
	channelCategories: '/v3.0/live/channelCategories.json',
	/** In-Player Browse Channels */
	inPlayerBrowse: '/v3.0/{device}/in-player-browse/live/channels.json',

	/** Converged: GET .../v3.0/{device}/movies/{contentId}.json */
	moviesBase: '/v3.0',
	/** Legacy list: GET .../movies.json?ids= */
	vodItems: '/v3.0/movies.json',
	/** VOD episode item: GET .../v2.0/videos/item.json?ids= */
	vodEpisodes: '/v2.0/videos/item.json',

	/** URL Resolver / Playback */
	streamingUrl: '/v4.0/streaming-url.json',
	transform: '/v1.0/transform',

	/** Platform session */
	start: '/v3.1/platform/start.json',
	restart: '/v3.1/platform/restart.json',

	/** Favorite channels / watchlist */
	watchlist: '/v3.1/user/watchlist.json',
	watchlistAdd: '/v3.1/user/watchlist/add.json',
	watchlistRemove: '/v3.1/user/watchlist/remove.json',
	watchlistChannelExists: '/v3.1/user/watchlist/channel',

	/** User favorites (VOD / assets) — converged apps-api user surface (paths align with watchlist routing) */
	favoritesAdd: '/v3.1/user/favorites/add.json',
	favoritesRemove: '/v3.1/user/favorites/remove.json',

	/** Home / Hub / Personalization */
	homeConfigurator: '/v3.2/home/configurator.json',
	collectionsItems: '/v3.5/collections',
	hub: '/v3.3/hub',

	/** UEC Up-Next recommendations */
	upNext: '/api/v3.2/amlg/recommendation/up-next.json',
	/** Episode-to-episode (next item) recommendations — separate path from up-next */
	nextItem: '/api/v3.2/amlg/recommendation/next-item.json'
} as const;